import React, { useEffect, useState } from "react";
import { getBlockedEmails, createBlockedEmail, deleteBlockedEmail } from "../../Services/BlockedEmails";
import Loader from "../../Layouts/Loader";

const BlockedEmails = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ email: "", note: "" });
  const [error, setError] = useState(null);

  const reload = () => {
    setLoading(true);
    getBlockedEmails()
      .then(res => setRows(res.data.data.responseData))
      .catch(() => setError("Failed to load blocklist"))
      .finally(() => setLoading(false));
  };

  useEffect(() => { reload(); }, []);

  const onCreate = () => {
    setCreating(true);
    setError(null);
    createBlockedEmail({ email: form.email, note: form.note || null })
      .then(() => { setForm({ email: "", note: "" }); reload(); })
      .catch(() => setError("Failed to add email"))
      .finally(() => setCreating(false));
  };

  const onDelete = (email) => {
    if (!window.confirm(`Remove ${email} from the blocklist? Lifecycle emails will resume for this address.`)) return;
    deleteBlockedEmail(email).then(reload).catch(() => setError("Failed to delete email"));
  };

  const validEmail = form.email.trim().includes("@");

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="page_header"><h2 className="mb-0">Email Blocklist</h2></div>
      </div>

      <div className="alert alert-info" role="alert">
        Addresses on this list never receive lifecycle emails. This is the single
        source of truth — check it before any manual mail merge.
      </div>

      {error && <div className="alert alert-danger" role="alert">{error}</div>}

      <div className="card mb-3">
        <div className="card-body">
          <div className="row g-2">
            <div className="col-md-4">
              <input className="form-control" type="email" placeholder="email@example.com" value={form.email} onChange={(e)=>setForm(f=>({...f, email: e.target.value}))}/>
            </div>
            <div className="col-md-6">
              <input className="form-control" placeholder="Note (optional, e.g. 'Requested removal 2026-08-18')" value={form.note} onChange={(e)=>setForm(f=>({...f, note: e.target.value}))}/>
            </div>
            <div className="col-md-2">
              <button className="btn btn-primary w-100" onClick={onCreate} disabled={creating || !validEmail}>Add</button>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          {loading ? <Loader /> : (
            <div className="table-responsive">
              <table className="table table-striped table-hover mb-0">
                <thead>
                  <tr>
                    <th>Email</th>
                    <th>Note</th>
                    <th>Added</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map(row => (
                    <tr key={row.email}>
                      <td>{row.email}</td>
                      <td>{row.note || ""}</td>
                      <td>{row.created_at ? row.created_at.slice(0, 10) : ""}</td>
                      <td>
                        <button className="btn btn-outline-danger btn-sm" onClick={()=>onDelete(row.email)}>Delete</button>
                      </td>
                    </tr>
                  ))}
                  {rows.length === 0 && (
                    <tr><td colSpan={4} className="text-center text-muted">No blocked emails</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BlockedEmails;
